// source: pbtypes/gen/skills/joysticks_control_scheme_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.JoysticksControlSchemeParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.JoysticksControlSchemeParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.JoysticksControlSchemeParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.JoysticksControlSchemeParams.displayName = 'proto.skills.JoysticksControlSchemeParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.JoysticksControlSchemeParams.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.JoysticksControlSchemeParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.JoysticksControlSchemeParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.JoysticksControlSchemeParams.toObject = function(includeInstance, msg) {
  var f, obj = {
maxSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
maxHeadingRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
headingRateDz: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
headingRateExpoValAtHalf: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
headingRateFilterTimeConstant: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.JoysticksControlSchemeParams}
 */
proto.skills.JoysticksControlSchemeParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.JoysticksControlSchemeParams;
  return proto.skills.JoysticksControlSchemeParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.JoysticksControlSchemeParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.JoysticksControlSchemeParams}
 */
proto.skills.JoysticksControlSchemeParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxSpeed(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxHeadingRate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeadingRateDz(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeadingRateExpoValAtHalf(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeadingRateFilterTimeConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.JoysticksControlSchemeParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.JoysticksControlSchemeParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.JoysticksControlSchemeParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.JoysticksControlSchemeParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getMaxHeadingRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getHeadingRateDz();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getHeadingRateExpoValAtHalf();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getHeadingRateFilterTimeConstant();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional double max_speed = 1;
 * @return {number}
 */
proto.skills.JoysticksControlSchemeParams.prototype.getMaxSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.JoysticksControlSchemeParams} returns this
 */
proto.skills.JoysticksControlSchemeParams.prototype.setMaxSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double max_heading_rate = 2;
 * @return {number}
 */
proto.skills.JoysticksControlSchemeParams.prototype.getMaxHeadingRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.JoysticksControlSchemeParams} returns this
 */
proto.skills.JoysticksControlSchemeParams.prototype.setMaxHeadingRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double heading_rate_dz = 3;
 * @return {number}
 */
proto.skills.JoysticksControlSchemeParams.prototype.getHeadingRateDz = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.JoysticksControlSchemeParams} returns this
 */
proto.skills.JoysticksControlSchemeParams.prototype.setHeadingRateDz = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double heading_rate_expo_val_at_half = 4;
 * @return {number}
 */
proto.skills.JoysticksControlSchemeParams.prototype.getHeadingRateExpoValAtHalf = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.JoysticksControlSchemeParams} returns this
 */
proto.skills.JoysticksControlSchemeParams.prototype.setHeadingRateExpoValAtHalf = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double heading_rate_filter_time_constant = 5;
 * @return {number}
 */
proto.skills.JoysticksControlSchemeParams.prototype.getHeadingRateFilterTimeConstant = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.JoysticksControlSchemeParams} returns this
 */
proto.skills.JoysticksControlSchemeParams.prototype.setHeadingRateFilterTimeConstant = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


goog.object.extend(exports, proto.skills);
